import Vue from 'vue';
import Chat from 'vue-beautiful-chat/dist/vue-beautiful-chat.umd.min';

export default async () => {

  Vue.use(Chat);
};
